export const BIOMETRIC_CONFIG_PREFIX = '__BIOMETRIC_CONFIG__';

export const BIOMETRIC_KINDS = {
  auto: {
    key: 'auto',
    code: 'BIOMETRIC_AUTO',
    name: 'Auto Biometric',
  },
  manual: {
    key: 'manual',
    code: 'BIOMETRIC_MANUAL',
    name: 'Manual Biometric',
  },
};

export const createEmptyBiometricConfig = (kind = 'auto') => ({
  version: 1,
  kind: kind === 'manual' ? 'manual' : 'auto',
  deviceCount: '',
  fee: '',
  renewalFee: '',
});

export const parseBiometricConfigFromNotes = (notes) => {
  if (!notes || typeof notes !== 'string') return null;
  if (!notes.startsWith(BIOMETRIC_CONFIG_PREFIX)) return null;
  try {
    const parsed = JSON.parse(notes.slice(BIOMETRIC_CONFIG_PREFIX.length));
    if (!parsed || (parsed.kind !== 'auto' && parsed.kind !== 'manual')) return null;
    return normalizeBiometricConfig(parsed);
  } catch {
    return null;
  }
};

export const serializeBiometricConfigToNotes = (config) =>
  `${BIOMETRIC_CONFIG_PREFIX}${JSON.stringify(normalizeBiometricConfig(config))}`;

export const normalizeBiometricConfig = (config) => ({
  version: 1,
  kind: config?.kind === 'manual' ? 'manual' : 'auto',
  deviceCount: config?.deviceCount ?? '',
  fee: config?.fee ?? '',
  renewalFee: config?.renewalFee ?? '',
});

export const calculateBiometricConfigTotal = (config) => {
  const count = parseFloat(config?.deviceCount) || 0;
  const fee = parseFloat(config?.fee) || 0;
  if (count <= 0 || fee < 0) return 0;
  return count * fee;
};

export const validateBiometricConfig = (config) => {
  const errors = [];
  const count = parseFloat(config?.deviceCount);
  const fee = parseFloat(config?.fee);
  const renewal = config?.renewalFee === '' || config?.renewalFee == null
    ? null
    : parseFloat(config.renewalFee);

  if (!count || count <= 0) {
    errors.push('Enter a valid number of devices.');
  }
  if (config?.fee === '' || config?.fee == null || Number.isNaN(fee) || fee < 0) {
    errors.push('Enter a valid fee.');
  }
  if (renewal != null && (Number.isNaN(renewal) || renewal < 0)) {
    errors.push('Enter a valid renewable fee.');
  }
  if (errors.length === 0 && calculateBiometricConfigTotal(config) <= 0) {
    errors.push('Total amount must be greater than zero.');
  }
  return { valid: errors.length === 0, errors };
};

export const formatBiometricCurrency = (value) => {
  const n = parseFloat(value) || 0;
  return `₹${n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const biometricKindLabel = (kind) =>
  kind === 'manual' ? BIOMETRIC_KINDS.manual.name : BIOMETRIC_KINDS.auto.name;
